module.exports = __webpack_public_path__ + "img/SRABANA MA'AM.41f47209.jpg";